module.exports = __webpack_public_path__ + "img/new-logo-horizontal.b0a703c1.svg";